import React, { useEffect } from 'react';
import { Box, Stack } from '@mui/material';
import { usePerformanceReportingContext } from './PerformanceReportingContext';
import MetricsCards from './MetricsCards';
import DimensionsCharts from './DimensionsCharts';
import TrendsChart from './TrendsChart';
import Top5Summaries from './Top5Summaries';
import useAssignedModules from './_data_sources/useAssignedModules';
import AssignedModuleFilter from './AssignedModuleFilter';

function PerformanceReportingContent() {
  const { orgId, childOrgId, assignedModule, setAssignedModule } = usePerformanceReportingContext();
  const { data: assignedModules } = useAssignedModules({ orgId, childOrgId });

  // Set default assigned module if none is selected
  useEffect(() => {
    if (!assignedModule && assignedModules && assignedModules.length > 0) {
      setAssignedModule(assignedModules[0].key);
    }
  }, [assignedModule, assignedModules, setAssignedModule]);

  // Don't render content until we have an assigned module
  if (!assignedModule || !assignedModules || assignedModules.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateRows: 'auto 1fr',
        height: '100%',
        minHeight: 0,
        width: '1200px',
        maxWidth: '94vw',
        mx: 'auto',
      }}
    >
      {/* Sticky Filter Row */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          py: 3,
          px: 5,
          position: 'sticky',
          top: 0,
          backgroundColor: 'background.default',
          zIndex: 1,
        }}
      >
        <AssignedModuleFilter />
      </Box>

      {/* Scrollable Content */}
      <Box
        sx={{
          overflow: 'auto',
          py: 3,
          px: 5,
          minHeight: 0,
        }}
      >
        <Stack
          spacing={6}
          sx={{ minWidth: 0 }}
        >
          {/* Metrics Cards */}
          <MetricsCards />

          {/* Dimensions Charts (Donut Charts) */}
          <DimensionsCharts />

          {/* Trends Chart (Area Chart) */}
          <TrendsChart />

          {/* Top-5 Summaries (Bar Charts) */}
          <Top5Summaries />
        </Stack>
      </Box>
    </Box>
  );
}

export default function PerformanceReporting() {
  return <PerformanceReportingContent />;
}
